import {
    SET_PLCC_DYNAMIC_BANNER,
    SET_PLCC_BANNER_HTML,
    SET_PLCC_DETAILS_HTML,
    SET_PLCC_SLIDER_OPEN,
} from '../actionTypes/PlccDynamicBannerActionTypes';

export default function PlccDynamicBannerReducer(state = {}, action) {
    // NOSONAR
    switch (action.type) {
        case SET_PLCC_DYNAMIC_BANNER:
            return { ...state, ...action.plccDynamicBanner };
        case SET_PLCC_BANNER_HTML:
            return { ...state, ...state.plccDynamicBanner, bannerHtml: action.response };
        case SET_PLCC_DETAILS_HTML:
            return { ...state, ...state.plccDynamicBanner, detailsHtml: action.response };
        case SET_PLCC_SLIDER_OPEN:
            return { ...state, plccSliderOpen: action.plccSliderOpen };
        default:
            return state;
    }
}
